// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:27
import { ScheduledOpReturnStatus_abstract } from './../../abstract/SagaBase/Objects/ScheduledOpReturnStatus_abstract';
export class ScheduledOpReturnStatus extends ScheduledOpReturnStatus_abstract {}
